import { Component, OnInit, Input, forwardRef } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { ComboComponent } from "../..";
import { RouterFilterReference } from "../../common/filters-router/filters-router.component";
import { FiltersTypeEnum } from 'world-archery-lib';

@Component({
  selector: "lib-text-filter",
  templateUrl: "./text-filter.component.html",
  styleUrls: ["./text-filter.component.scss"],
  providers:[ {provide: RouterFilterReference, useExisting: forwardRef(() => TextFilterComponent)}]

})
export class TextFilterComponent extends RouterFilterReference {
  @Input()
  id: string;
  /**
   *
   * Default text value of filter
   * @memberof TextFilterComponent
   */
  @Input()
  defaultTextValue = "";

  /**
   *
   * Subject that must send value when input changes
   * @type {BehaviorSubject<string>}
   * @memberof TextFilterComponent
   */
  @Input() text_subject: BehaviorSubject<string>;
  constructor() {
    super(FiltersTypeEnum.TextSearch);
  }

  onChangeText(event) {
    this.text_subject.next(event);
    this.changeData.emit(event);
  }
}
